/**
 * Route for `api-key-generation-permission-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApiKeyGenerationPermissionPerRolePage } from "../features/api-key-generation-permission-per-role/ApiKeyGenerationPermissionPerRolePage";

export const apiKeyGenerationPermissionPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/api-key-generation-permission-per-role",
	component: ApiKeyGenerationPermissionPerRolePage,
});

export default apiKeyGenerationPermissionPerRoleRoute;
